import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a7987eb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row left" }
const _hoisted_2 = { class: "col-md-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Order rules")
], -1))
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label me-2" }, "Payment Branch", -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label me-2" }, "Production Branch", -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label me-2" }, "Operator", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "Unlimited", -1))
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label me-2" }, "Limit", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Order output")
], -1))
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label me-2" }, "Delivery Branch", -1))
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "mb-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label me-2" }, "State", -1))
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "row left" }
const _hoisted_25 = { class: "col-md-2" }
const _hoisted_26 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_notification = _resolveComponent("k-notification")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_k_notification, { ref: "PopupNotification" }, null, 512),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("select", {
            id: "Type",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.PaymentBranchId) = $event)),
            class: "form-select",
            "aria-label": "Select Type"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Branches, (item) => {
              return (_openBlock(), _createElementBlock("option", {
                key: item.Id,
                value: item.Id
              }, _toDisplayString(item.Name), 9, _hoisted_6))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.model.PaymentBranchId]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("select", {
            id: "Type",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.ProductionBranchId) = $event)),
            class: "form-select",
            "aria-label": "Select Type"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Branches, (item) => {
              return (_openBlock(), _createElementBlock("option", {
                key: item.Id,
                value: item.Id
              }, _toDisplayString(item.Name), 9, _hoisted_9))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.model.ProductionBranchId]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("select", {
            id: "Type",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.Operator) = $event)),
            class: "form-select",
            "aria-label": "Select Type"
          }, [
            _hoisted_12,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.LimitOperators, (item) => {
              return (_openBlock(), _createElementBlock("option", {
                key: item.Id,
                value: item.Id
              }, _toDisplayString(item.Name), 9, _hoisted_13))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.model.Operator]
          ])
        ]),
        (_ctx.model.Operator != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _hoisted_15,
              _withDirectives(_createElementVNode("input", {
                id: "Limit",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.Limit) = $event)),
                type: "number",
                class: "form-control"
              }, null, 512), [
                [_vModelText, _ctx.model.Limit]
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_16,
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _withDirectives(_createElementVNode("select", {
            id: "Type",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.DeliveryBranchId) = $event)),
            class: "form-select",
            "aria-label": "Select Type"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Branches, (item) => {
              return (_openBlock(), _createElementBlock("option", {
                key: item.Id,
                value: item.Id
              }, _toDisplayString(item.Name), 9, _hoisted_20))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.model.DeliveryBranchId]
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _withDirectives(_createElementVNode("select", {
            id: "Type",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.OutputState) = $event)),
            class: "form-select",
            "aria-label": "Select Type"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.States, (item) => {
              return (_openBlock(), _createElementBlock("option", {
                key: item.Id,
                value: item.Id
              }, _toDisplayString(item.Name), 9, _hoisted_23))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.model.OutputState]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("button", {
          disabled: _ctx.invalidInput,
          class: "btn m-2 btn-primary",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.save()))
        }, " Save ", 8, _hoisted_26)
      ])
    ])
  ], 64))
}